class addFields {
  constructor() {
    this.bindEvents()
  }

  bindEvents() {
    document.addEventListener("click", e => {
      let link = e.target.closest(".add_fields")
      if (!link) return

      this.handleClick(link, e)
    })
  }

  handleClick(link, e) {
    if (!link || !e) return

    e.preventDefault()

    let time = new Date().getTime()
    let linkId = link.dataset.id
    let regexp = linkId ? new RegExp(linkId, "g") : null
    let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
    if (!newFields) return

    let targetSelector = link.classList.contains("add-sub-zone-btn") ? ".sub-zones-section" : null
    let target = targetSelector ? link.closest(targetSelector) : null
    let targetContainer = target ? target.querySelector("[data-nested-target-container]") : null

    if (targetContainer) {
      targetContainer.insertAdjacentHTML("beforeend", newFields)
      return
    }

    link.insertAdjacentHTML("beforebegin", newFields)
  }
}

window.addEventListener("DOMContentLoaded", () => new addFields())
